module.exports = __webpack_public_path__ + "static/img/bg_lottery_b.2a10c16.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg_lottery_b.png
// module id = 8bSe
// module chunks = 1